module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "global-mentorship"
  }, [_c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), (_vm.calendarEvents) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('full-calendar', {
    ref: "calendar",
    attrs: {
      "self": _vm.self,
      "config": _vm.config,
      "header": _vm.calendarHeader,
      "events": _vm.calendarEvents
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.participants) ? _c('global-meeting-participants', {
    attrs: {
      "participants": _vm.participants,
      "link": _vm.link,
      "recordingProcessing": _vm.recordingProcessing,
      "hasRecording": _vm.hasRecording,
      "maxParticipants": _vm.maxParticipants
    },
    on: {
      "closeModal": function($event) {
        _vm.participants = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Meetings")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7fd77caa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GlobalMentorship.vue
// module id = 2094
// module chunks = 2